import React, { useEffect, useId, useRef } from 'react'
import { Form, InputGroup } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBarcode } from '@fortawesome/pro-regular-svg-icons'

import { FieldHint } from '../styles'

interface RfScanFieldProps {
  label: string
  value: string
  placeholder: string
  hint?: string
  disabled?: boolean
  onChange: (value: string) => void
}

export const RfScanField = ({ label, value, placeholder, hint, disabled = false, onChange }: RfScanFieldProps) => {
  const inputRef = useRef<HTMLInputElement | null>(null)
  const inputId = useId()
  const hintId = `${inputId}-hint`

  useEffect(() => {
    if (!disabled) {
      inputRef.current?.focus()
      inputRef.current?.select()
    }
  }, [disabled])

  return (
    <Form.Group controlId={inputId}>
      <Form.Label>{label}</Form.Label>
      <InputGroup>
        <InputGroup.Text aria-hidden="true">
          <FontAwesomeIcon icon={faBarcode} />
        </InputGroup.Text>
        <Form.Control
          ref={inputRef}
          type="text"
          autoComplete="off"
          inputMode="none"
          value={value}
          placeholder={placeholder}
          aria-describedby={hint ? hintId : undefined}
          disabled={disabled}
          onChange={(event) => onChange(event.target.value)}
        />
      </InputGroup>
      {hint ? <FieldHint id={hintId}>{hint}</FieldHint> : null}
    </Form.Group>
  )
}
